import validate from './validate';
import { measureSmsLength } from './smsLength';

// A stored template sent as is goes by id, so the server never checks its text.
export function isStoredTemplateAsIs({ smsSelectedTemplate, smsText }) {
  return Boolean(
    smsSelectedTemplate &&
      smsSelectedTemplate.id &&
      smsSelectedTemplate.id !== '__no_template__' &&
      smsSelectedTemplate.sms_text === smsText,
  );
}

// The drawer renders the length message from the live text under its counter, so it clears as
// the text changes. The key only blocks the submit. The cap is Bird's, so an account on another
// provider is never blocked.
export default function validateBulk(values, usingBird) {
  const errors = validate(values);

  if (
    usingBird &&
    !isStoredTemplateAsIs(values) &&
    measureSmsLength(values.smsText).exceedsLimit
  ) {
    errors.smsLength = true;
  }

  return errors;
}
